<template>
  <a-modal
      v-model="visible"
      width="720px"
      :footer="null"
      centered
      class="smart-wrapper"
  >
    <div slot="title">
      <div class="title-box">
        <img src="https://prod-ylzapp-public.oss-cn-zhangjiakou.aliyuncs.com/frontend/shipper-admin/images/icon_scan_black.png" /> 智能地址识别
      </div>
    </div>
    <div v-loading="loading" class="content-info">
      <div class="tips">粘贴地址信息到下方输入框</div>
      <a-textarea
          v-model="text"
          class="textarea"
          placeholder="示例：王明，18245569586，四川省成都市锦江区三色路17号"
          :auto-size="{ minRows: 4, maxRows: 6 }"
      />
    </div>
    <div class="site-footer">
      <a-button class="cancel" @click="hide">取消</a-button>
      <a-button type="primary" @click="handleConfirm">确定</a-button>
    </div>
  </a-modal>
</template>

<script>
import { getSmartAddress } from "@/api/user";

export default {
  name: 'SmartRecognitionModal',
  components: {

  },
  props: {

  },
  data() {
    return {
      visible:false,
      text:'',
      loading: false,
    };
  },
  computed: {

  },
  methods: {
    async handleConfirm(){
      if(!this.text) {
        this.$message.warn('地址信息不能为空哟！')
        return
      }
      try {
        const res = await getSmartAddress({
          text:this.text,
          sceneCode: 'aliquip nostrud ad',
          providerType: 'BAIDU',
          businessType:'ADDRESS'
        })
        const {result} = res

        if(result) {
          const {
            person:contacts, phonenum: telPhone,
              province:provinceName, city:cityName, county:countyName, detail:address,
              province_code:provinceCode, city_code:cityCode, county_code:countyCode
          } = result
          this.$emit('onConfirm', {
            contacts,
            telPhone,
            provinceName,
            cityName,
            countyName,
            address,
            provinceCode,
            cityCode,
            countyCode
          })
          this.hide()
        }
      }catch (e) {
        this.$message.warn(e.msg ||'地址识别错误')
      }


    },
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },

  },
}
</script>
<style lang="less" scope>
.title-box {
  display: flex;
  align-items: center;
  img {
    width: 22px;
    height: 22px;
    margin-right: 4px;
  }
}
.content-info{
  max-height: 700px;
  overflow: auto;
  .tips {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: var(--el-text-color-regular);
    margin-bottom: 8px;
  }
  .textarea {

  }
  margin-bottom: 24px;
}
.site-footer {
  display: flex;
  justify-content: flex-end;
  .cancel {
    margin-right: 12px;
  }
}
</style>
